import React from "react";
import "../assets/styles/css/Homepage.scss";
import {
  Body,
  LandingBody,
} from "../assets/styles/styled-components/GlobalStyles";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

export default function Homepage() {
  const collapsed = useSelector((state) => state.sidebar.isCollaped);

  return (
    <Body isCollapsed={collapsed}>
      <LandingBody>
        <div className="left-landing">
          <h1>Hi, I'm</h1>
          <h2 className="animation">Chanantaphon</h2>
          <h2 className="animation">Chansuksri (Man)</h2>
          <h3>
            {"< "}Software Engineer / Software Developer{" />"}
          </h3>
          <Link className="btn" to="/work">
            View my work
          </Link>
        </div>
        <div className="right-landing">
          <div className="right-landing-inner">
          </div>
        </div>
      </LandingBody>
    </Body>
  );
}
